module.exports = __webpack_public_path__ + "img/transition_enroll_tp.5bdb575c.png";